module.exports = __webpack_public_path__ + "img/247.3b4e5c8e.jpg";